/* eslint-disable */
import React, { useState } from "react";
import {
  Flex,
  Box,
  Input,
  IconButton,
  useBreakpointValue,
  Text,
  Link,
  useDisclosure,
  useToast,
  Button,
  Spinner,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  Heading,
  Icon,
  VStack,
  Switch,
  FormLabel,
  useColorMode,
  useColorModeValue,
  Select
} from "@chakra-ui/react";
import { FaSearch, FaBars, FaEnvelope, FaBrain } from "react-icons/fa";
import Dropdown from "./Dropdown";
import EmailOutboxDrawer from "./EmailOutboxDrawer";
import { useLocation, useNavigate } from "react-router-dom";
import { NavBarDrawer } from "../NavBarDrawer";
import { showToast } from "../SignUp";
import axios from "axios";
import { useModalToast } from "../../context/GlobalModalToast";
import { useLanguage } from "../../context/LanguageContext";

const Navbar = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const isMobile = useBreakpointValue({ base: true, lg: false });
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('user')) || { role: '' };


  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOutboxOpen, onOpen: onOutboxOpen, onClose: onOutboxClose } = useDisclosure();

  const [showSearchBar, setShowSearchBar] = useState(false);
  const { toast } = useModalToast();
  const location = useLocation();

  const { isOpen: isAiOpen, onOpen: onAiOpen, onClose: onAiClose } = useDisclosure();
  const [messages, setMessages] = useState([
    { sender: "ai", text: "Hello! I am Eram Pilot. 🌟\n\nI can recommend the perfect training courses for your role, tell you about current compliance assignments, or explain any professional concept or technical term. What would you like to learn today?" }
  ]);
  const [aiInput, setAiInput] = useState("");
  const [isAiLoading, setIsAiLoading] = useState(false);

  const drawerBg = useColorModeValue("white", "gray.900");
  const drawerBodyBg = useColorModeValue("gray.50", "gray.800");
  const aiMessageBg = useColorModeValue('white', 'gray.700');
  const aiMessageColor = useColorModeValue('gray.800', 'gray.100');
  const aiMessageBorder = useColorModeValue("gray.150", "gray.600");
  const inputBg = useColorModeValue("white", "gray.900");
  const inputBorder = useColorModeValue("gray.100", "gray.700");
  const { language, toggleLanguage, t } = useLanguage();

  const handleSendAi = async () => {
    if (!aiInput.trim()) return;
    const textToSend = aiInput;
    setMessages(prev => [...prev, { sender: "user", text: textToSend }]);
    setAiInput("");
    setIsAiLoading(true);

    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token;
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/dashboard/ask-ai`, {
        question: textToSend
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMessages(prev => [...prev, { sender: "ai", text: response.data.answer }]);
    } catch (err) {
      console.error(err);
      const errMsg = err.response?.data?.message || err.response?.data || "Sorry, I ran into an issue answering your question. Please try again.";
      setMessages(prev => [...prev, { sender: "ai", text: errMsg }]);
    } finally {
      setIsAiLoading(false);
    }
  };
  function home() {
    navigate("/home");
  }

  function handleShowSearchBar() {
    setShowSearchBar(!showSearchBar);
    if (showSearchBar && location.pathname === "/home") {
      showToast({
        toast,
        message: `Below is you search Result`,
        color: "green"});
    }
  }

  return (
    <Box>
      <Flex
        as="nav"
        align="center"
        justify="space-between"
        px={{ base: 4, md: 8 }}
        py={3.5}
        bg="rgba(244, 242, 255, 0.94)"
        backdropFilter="blur(20px)"
        boxShadow="0 1px 0 rgba(124,111,247,0.14), 0 6px 24px rgba(124,111,247,0.07)"
        position="fixed"
        width="100%"
        zIndex={1000}
        top={0}
        borderBottom="1px solid"
        borderColor="rgba(124,111,247,0.13)"
      >
        <Flex align="center" onClick={home} _hover={{ cursor: "pointer" }}>
          <img src="/Workforce.svg" alt="Workforce Logo" style={{ height: "100px", objectFit: "contain" }} />
        </Flex>

        {!isMobile ? (
          <Flex align="center" maxW="450px" w="full" mx={10}>
            <Input
              type="text"
              variant="filled"
              bg="var(--bg-raised)"
              border="1px solid var(--border-soft)"
              fontSize="sm"
              placeholder={t("What do you want to learn?")}
              borderRadius="full"
              _focus={{ bg: "var(--bg-surface)", borderColor: "var(--primary)", boxShadow: "var(--shadow-glow)" }}
              _placeholder={{ color: "var(--text-placeholder)" }}
              px={6}
            />
          </Flex>
        ) : (
          <Flex align="center">
            <IconButton
              aria-label="Menu"
              icon={<FaBars />}
              bg="transparent"
              color="#0056d2"
              fontSize="2xl"
              mr={2}
              onClick={onOpen}
            />
          </Flex>
        )}
        {/* small screen search bar and icon  */}
        {isMobile &&
          location.pathname ===
          "/home" && (
            <Box>
              {showSearchBar ? (
                <Flex align="center">
                  <Box>
                    {/* Search Bar */}
                    <Input
                      type="text"
                      variant="filled"
                      border="1px solid black"
                      fontSize="0.8rem"
                      m="0 2rem"
                      color="black"
                      placeholder="Find your new Skiil!"
                      borderRadius="10px 0 0px 10px"
                      _placeholder={{
                        color: "#555454",
                        letterSpacing: "0.5px"}}
                    />
                  </Box>
                  <IconButton
                    aria-label="Search"
                    icon={<FaSearch />}
                    bg="#0056d2"
                    onClick={handleShowSearchBar}
                    color="white"
                    borderRightRadius="7px"
                    borderRadius="0px 10px 10px 0px"
                  />
                </Flex>
              ) : (
                <IconButton
                  aria-label="Search"
                  icon={<FaSearch />}
                  color="white"
                  borderRadius="7px"
                  bg="#0056d2"
                  onClick={handleShowSearchBar}
                  _hover={{ backgroundColor: "#003e9c", color: "white" }}
                />
              )}
            </Box>
          )}

        {!isMobile && (
          <Flex align="center">
            <Flex align="center" mr={4}>
              <FormLabel htmlFor="student-mode-switch" mb="0" mr={2} fontSize="sm" fontWeight="bold" cursor="pointer">
                {colorMode === "light" ? "🌙" : "☀️"}
              </FormLabel>
              <Switch
                id="student-mode-switch"
                colorScheme="purple"
                isChecked={colorMode === "dark"}
                onChange={toggleColorMode}
              />
            </Flex>
            <IconButton
              aria-label="Simulated Outbox"
              icon={<FaEnvelope />}
              colorScheme="purple"
              variant="ghost"
              mr={3}
              fontSize="xl"
              onClick={onOutboxOpen}
              position="relative"
              _hover={{ transform: "scale(1.08)" }}
              transition="all 0.2s"
            />
            <Box>
              <Dropdown />
            </Box>
          </Flex>
        )}
      </Flex>
      <NavBarDrawer isOpen={isOpen} onOpen={onOpen} onClose={onClose} />
      <EmailOutboxDrawer isOpen={isOutboxOpen} onClose={onOutboxClose} />

      {/* Floating AI Mentor Chatbot */}
      {JSON.parse(localStorage.getItem('user'))?.token && !location.pathname.startsWith('/course/') && (
        <>
          <Button
            position="fixed"
            bottom={8}
            right={8}
            bg="var(--primary)"
            _hover={{ bg: "var(--primary-hover)", transform: "translateY(-3px)", boxShadow: "0 12px 28px rgba(124,111,247,0.45)" }}
            _active={{ bg: "var(--primary-hover)" }}
            transition="all 0.25s cubic-bezier(0.16,1,0.3,1)"
            color="white"
            borderRadius="full"
            h="54px"
            px={7}
            boxShadow="0 6px 20px rgba(124,111,247,0.35)"
            zIndex={1000}
            leftIcon={<Icon as={FaBrain} />}
            onClick={onAiOpen}
            fontSize="sm"
            fontWeight="700"
          >
            Ask Eram Pilot
          </Button>

          <Drawer isOpen={isAiOpen} placement="right" onClose={onAiClose} size="md">
            <DrawerOverlay backdropFilter="blur(4px)" />
            <DrawerContent borderLeftRadius="2xl" overflow="hidden" bg={drawerBg}>
              <DrawerCloseButton color="white" zIndex={2000} />

              <Box bgGradient="linear(to-r, purple.600, blue.600)" p={6} color="white">
                <Flex align="center" gap={3}>
                  <Icon as={FaBrain} w={6} h={6} />
                  <Box>
                    <Heading size="md" fontWeight="800">Eram Pilot</Heading>
                    <Text fontSize="xs" opacity={0.9}>Corporate Pathway & Recommendation AI</Text>
                  </Box>
                </Flex>
              </Box>

              <DrawerBody bg={drawerBodyBg} p={4} display="flex" flexDir="column" gap={4} overflowY="auto">
                <Flex direction="column" gap={3} flex={1}>
                  {messages.map((m, idx) => (
                    <Flex
                      key={idx}
                      justify={m.sender === 'user' ? 'flex-end' : 'flex-start'}
                    >
                      <Box
                        maxW="80%"
                        p={3.5}
                        borderRadius="2xl"
                        bgGradient={m.sender === 'user' ? 'linear(to-r, purple.500, blue.500)' : undefined}
                        bg={m.sender === 'user' ? undefined : aiMessageBg}
                        color={m.sender === 'user' ? 'white' : aiMessageColor}
                        boxShadow="sm"
                        fontSize="sm"
                        border={m.sender === 'ai' ? '1px solid' : 'none'}
                        borderColor={aiMessageBorder}
                      >
                        <Text whiteSpace="pre-line">{m.text}</Text>
                      </Box>
                    </Flex>
                  ))}
                  {isAiLoading && (
                    <Flex justify="flex-start">
                      <Box maxW="80%" p={3.5} borderRadius="2xl" bg={aiMessageBg} shadow="sm" border="1px solid" borderColor={aiMessageBorder}>
                        <Spinner size="xs" color="purple.500" />
                      </Box>
                    </Flex>
                  )}
                </Flex>
              </DrawerBody>

              <Box p={4} bg={inputBg} borderTop="1px solid" borderColor={inputBorder}>
                <Flex gap={2}>
                  <Input
                    placeholder="Ask for recommendations or career guidance..."
                    value={aiInput}
                    onChange={(e) => setAiInput(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleSendAi()}
                    borderRadius="xl"
                  />
                  <Button bgGradient="linear(to-r, purple.500, blue.500)" _hover={{ bgGradient: "linear(to-r, purple.600, blue.600)" }} color="white" borderRadius="xl" onClick={handleSendAi}>Send</Button>
                </Flex>
              </Box>
            </DrawerContent>
          </Drawer>
        </>
      )}
    </Box>
  );
};

export default Navbar;
